<template>
    <section class="app-main">
        
        <div class="top-bar">
            <el-button  class="top-btn" type="success" plain @click="handleShow(1)">添加</el-button >
            <el-button  class="top-btn" type="danger"  plain @click="handleDel()">删除</el-button >
        </div>

        <el-card shadow="hover">
            <el-table :data="tableData"  max-height="600" style="width: 100%">
                <el-table-column type="selection" width="80" align="center"> </el-table-column>
                <el-table-column label="图标"  align="center" width="300">
                    <template slot-scope="scope">
                        <el-image class="boss-img" :src="scope.row.bossimg" fit="fit"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="名称" align="center" ></el-table-column>
                <el-table-column prop="title" label="排序" align="center" ></el-table-column>
                <el-table-column prop="date"  align="center" label="时间" ></el-table-column>
                <el-table-column label="编辑" align="center">
                <template slot-scope="scope">
                    <el-button type="success" plain size="small"  @click="handleShow(2, scope.row)">修改</el-button>
                    <el-button type="danger"  plain size="small"  @click="handleDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next" style="padding:15px" :total="total" :page-size="20"></el-pagination>
        </el-card>



        <el-dialog :visible.sync="dialog" :title="dialogTitle"  width="800px" >
           <el-row class="item-input">
               <el-col :span="4">金刚区名称：</el-col>
               <el-col :span="20">
                   <el-input placeholder="输入金刚区名称" v-model="name"  style="width:500px;"></el-input>
               </el-col>
           </el-row>
           <el-row class="item">
               <el-col :span="4">金刚区图标：</el-col>
               <el-col :span="20">
                    <m-upload :img.sync="img" :width="120" :height="120" file-name="KingKong" ></m-upload>
                </el-col>
           </el-row>
           <el-row class="item-input">
               <el-col :span="4">排序：</el-col>
               <el-col :span="20">
                   <el-input v-model="sort"  style="width:500px;"></el-input>
               </el-col>
           </el-row>
           <el-row type="flex" class="row-bg" justify="center" v-if="dialogType == 2">
                <el-col :span="6" style="text-align:center"><el-button  type="primary" @click="dialog = false">取消修改</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button  type="success" @click="dialog = false">确定修改</el-button></el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="center" v-else>
                <el-col :span="6" style="text-align:center"><el-button  type="primary" @click="dialog = false">取消添加</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button  type="success" @click="dialog = false">确定添加</el-button></el-col>
            </el-row>
        </el-dialog>


    </section>
</template>



<script>

import MUpload from '@/components/m-upload.vue'

export default {
    components: { MUpload },
    data() {
        return {
            tableData:[],
            total:0,
            page:1,
            dialog:false,    // 控制显示 添加修改弹窗
            dialogType: 1,
            dialogTitle:'添加广告位',
            id:'',           //  有id 是修改  没有id是添加
            name:'',
            img: { url: '', pic_id: '' },
            sort:'0',
        }
    },
    methods: {
       
    
        getData(){
           
        },

        goodsDel(){
            
        },
        // 显示 添加 || 修改 弹窗
        handleShow(type ,row){
            this.dialogType = type
            if(type == 2){
                this.dialog      = true
                this.dialogTitle = '修改广告位'
                this.id        = row.id
                this.name      = row.title
                this.path      = row.path
                this.identify  = row.identify
                this.sort      = row.sort_id
                this.status    = row.status
                this.is_module = row.is_module
                this.pid       = row.pid
            }else{
                this.dialog      = true
                this.dialogTitle = '添加广告位'
                this.id        = ''
                this.name      = ''
                this.path      = ''
                this.sort      = 0
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        handleBossEdit(){
           
        }
    },
    created(){
        this.getData()
    }
}
</script>

<style lang="less" scoped>
section {
    width: 100%;
    height: 100%;
    .top-btn {
        width: 80px;
        margin-right: 15px;
    }
    .item-input {
        margin: 20px 0;
        height: 40px;
        line-height: 40px;
    }
}
</style>
